import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { NotificationContainer, NotificationManager, } from "react-notifications";
import DashboardHeader from './DashboardHeader';



const AcademicInformation = () => {
  const auth = JSON.parse(localStorage.getItem("auth_user_info"));
  const applicantID = auth ? auth.id : null;
  const [rows, setRows] = useState([
    {
      applicantId: applicantID,
      id: null,
      jobTitle: null,
      nameOfEmployer: null,
      organizationName: null,
      present: false,
      typeOfJob: null,
      yearEnd: null,
      yearStart: null
    }
  ]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();





  // Fetches data from the server and sets it to rows.
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/applicant/get-application`, {
          headers: {
            'accept': '*/*',
            'ApplicantId': applicantID,
            'Event': 'employment',
            'SessionKey': '123'
          }
        });

        if (response.data.data) {
          const mappedData = response.data.data.map(item => ({
            applicantId: applicantID,
            id: item.id,
            jobTitle: item.title || "Enter value",
            // nameOfEmployer: item.employer || "Enter value",
            organizationName: item.organization || "Enter value",
            present: item.present,
            typeOfJob: item.jobtype || "Enter value",
            yearEnd: item.yearEnd !== null ? item.yearEnd : null,
            yearStart: item.yearStart !== null ? item.yearStart : null
          }));
          setRows(mappedData);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching employment data:', error);
        NotificationManager.error(error.message, "Error");
        setLoading(false);
      }
    };

    fetchData();
  }, []);




  // Data Posting Model
  const handleAddMore = () => {
    setRows([...rows, {
      applicantId: applicantID,
      id: null,
      jobTitle: null,
      // nameOfEmployer: null,
      organizationName: null,
      present: false,
      typeOfJob: null,
      yearEnd: null,
      yearStart: null
    }]);
    // console.log(rows);
  };

  const handleRemove = (index) => {
    setRows(rows.filter((row, i) => i !== index));
  };

  const keyToName = {
    jobTitle: 'Job Title',
    // nameOfEmployer: 'Name of Employer',
    organizationName: 'Type of Job',
    typeOfJob: 'Organization Name',
    yearStart: 'Start Year'
  }

  // const handleInputChange = (index, field, value) => {
  //   setRows(rows.map((row, i) => {
  //     if (i !== index) return row;
  //     return { ...row, [field]: field === 'yearStart' || field === 'yearEnd' ? parseInt(value) : value };
  //   }));
  // };

  const handleInputChange = (index, field, value) => {
    setRows(rows.map((row, i) => {
      if (i !== index) return row;
      let newRow = { ...row, [field]: field === 'yearStart' || field === 'yearEnd' ? parseInt(value) : value };
      if (field === 'yearStart') {
        newRow.yearEnd = newRow.yearEnd >= value ? newRow.yearEnd : 0;
      } else if (field === 'yearEnd') {
        newRow.yearStart = newRow.yearStart <= value ? newRow.yearStart : 0;
      }
      return newRow;
    }));
  };


  // Post Request
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate the input
    let allFieldsFilled = true;
    // Find the highest id in the rows array
    // let highestId = Math.max(...rows.map(row => row.id || 0));

    rows.forEach((row, index) => {
      // If row.id does not exist, assign it the highestId + 1
      if (!row.id) {
        // highestId++;
        row.id = 0;
      }
      // console.log(rows);
      Object.keys(row).forEach((field) => {
        if (!row[field] && field !== 'yearEnd' && field !== 'present' && field !== 'nameOfEmployer' && field !== 'id') {
          NotificationManager.error("Field is required", keyToName[field]);
          console.log(row);
          allFieldsFilled = false;
        }
      });
    });

    if (!allFieldsFilled) {
      return;
    }

    const url = `${process.env.REACT_APP_BASE_URL}/applicant/employment`;

    try {
      const response = await axios.post(url, rows, {
        headers: {
          'Accept': '*/*',
          'SessionKey': '123',
          'Content-Type': 'application/json'
        }
      });

      navigate("/application/resume");
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        console.error('Error:', error.response.data);
        NotificationManager.error(error.response.data.message, "Error");
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error:', error.request);
        NotificationManager.error("No response received", "Error");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error:', error.message);
        NotificationManager.error(error.message, "Error");
      }
    }

  };

  // Year Array
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1998 }, (v, i) => ({ id: i + 1, year: (1999 + i).toString() }));


  return (
    <div>
      {/* Header Start */}
      <div className="mb-5">
        <DashboardHeader />
      </div>
      <div className="container row justify-content-center m-auto mb-5">
        <div className="col-md-10">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-4">
              <Navbar />
            </div>
            <div className="col-sm-12 col-md-8 mb-4">
              {loading ? (
                <div className="d-flex justify-content-center">
                  <div className="spinner-bubble spinner-bubble-primary m-5"></div>
                </div>

              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="card">
                    <div className="card-body">
                      <h4>Professional Details</h4>
                      <p className='my-3'>Please proceed by providing your most recent professional information.</p>
                      <div className="row">
                        {rows && rows.map((row, index) => (
                          <React.Fragment key={index}>
                            {/* <h5>{row.jobTitle || 'Please proceed by providing your most recent professional information.'}</h5> */}
                            <div className="form-group mb-3 col-sm-12 col-md-4">
                              <label htmlFor={`jobTitle${index}`} className="">
                                Job Title <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id={`jobTitle${index}`}
                                placeholder="Enter Job Title"
                                value={row.jobTitle || ''}
                                onChange={(e) => handleInputChange(index, 'jobTitle', e.target.value)}
                              />
                            </div>

                            <div className="form-group mb-3 col-sm-12 col-md-4">
                              <label htmlFor={`organizationName${index}`} className="">
                                Organization Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id={`organizationName${index}`}
                                placeholder="Enter Organization Name"
                                value={row.organizationName || ''}
                                onChange={(e) => handleInputChange(index, 'organizationName', e.target.value)}
                              />
                            </div>

                            <div className="form-group mb-3 col-sm-12 col-md-4">
                              <label htmlFor={`typeOfJob${index}`}>Type of Job <span className="text-danger">*</span></label>
                              <select
                                id={`typeOfJob${index}`}
                                className="form-control"
                                name="typeOfJob"
                                value={row.typeOfJob || ''}
                                onChange={(e) => handleInputChange(index, 'typeOfJob', e.target.value)}
                              >
                                <option value="">Please select job type</option>
                                <option value="Internship">Internship</option>
                                <option value="Part Time">Part Time</option>
                                <option value="Full Time">Full Time</option>
                              </select>
                            </div>
                            <div className="form-group mb-3 col-sm-12 col-md-4">
                              <label htmlFor={`yearStart${index}`}>Start Year <span className="text-danger">*</span></label>
                              {/* <pre>{row.yearStart.toString()}</pre> */}
                              <select
                                id={`yearStart${index}`}
                                className="form-control"
                                name="yearStart"
                                value={row.yearStart || 0}
                                onChange={(e) => handleInputChange(index, 'yearStart', e.target.value)}
                              >
                                {row.yearStart === null || row.yearStart === 0 ? <option key={0} value={0}>Select Start Year</option> : null}

                                {years.map((item) => (
                                  <option key={item.id} value={item.year}>
                                    {item.year}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="form-group mb-3 col-sm-12 col-md-4">

                              {row.present ? null : (<span>
                                <label htmlFor={`yearEnd${index}`}>End Year</label>
                                <select
                                  id={`yearEnd${index}`}
                                  className="form-control"
                                  name="yearEnd"
                                  value={row.yearEnd || 0}
                                  onChange={(e) => handleInputChange(index, 'yearEnd', e.target.value)}
                                >

                                  {row.yearEnd === null || row.yearEnd === 0 ? <option key={0} value={0}>Select End Year</option> : null}
                                  {years.filter((year) => year.year >= row.yearStart).map((year) => (
                                    <option key={year.id} value={year.year}>
                                      {year.year}
                                    </option>
                                  ))}
                                </select>
                              </span>


                              )}
                            </div>

                            <div className="form-group mb-3 col-sm-12 col-md-4">
                              <div className="ul-widget-app__task-list mt-4 pt-2">
                                <label className="checkbox checkbox-primary ">
                                  <input type="checkbox" name="present" checked={row.present || false} onChange={(e) => handleInputChange(index, 'present', e.target.checked)} />
                                  <strong>
                                    On-going
                                  </strong>
                                  <span className="checkmark"></span>
                                </label>
                              </div>
                              {/* <div className="mt-3">
                                <input
                                  type="checkbox"
                                  id={`presentcheck${index}`}
                                  name="present"
                                  className="mx-1  mt-4"
                                  checked={row.present || false}
                                  onChange={(e) => handleInputChange(index, 'present', e.target.checked)}
                                />
                                <label htmlFor={`presentcheck${index}`} className="d-inline-block mt-4">On-going</label>

                              </div> */}

                            </div>

                            {/* <div className="form-group mb-3 col-sm-12 col-md-4">
                              <label htmlFor={`nameOfEmployer${index}`} className="">
                                Name of Employer <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id={`nameOfEmployer${index}`}
                                placeholder="Name of Employer"
                                value={row.nameOfEmployer || ''}
                                onChange={(e) => handleInputChange(index, 'nameOfEmployer', e.target.value)}
                              />
                            </div> */}
                            <div className="form-group mb-4 col-12">
                              {rows.length > 1 && (
                                <button type="button" className="btn btn-danger text-white mt-4" onClick={() => handleRemove(index)}>
                                  Remove
                                </button>
                              )}
                            </div>
                          </React.Fragment>
                        ))}
                      </div>
                      <div className="text-left">
                        <button type="button" className="btn btn-secondary" onClick={handleAddMore}>
                          Add More
                        </button>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="mc-footer">
                        <div className="row text-center">
                          <div className="col-lg-12">
                            <button type="submit" className="btn btn-primary text-white m-1">
                              Save & Next
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-secondary m-1"
                              onClick={() => navigate('/application/resume')}
                            >
                              Skip
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}


            </div>
          </div>
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
};

export default AcademicInformation;
